import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { searchWorkersAction, clearWorkersPredictionsList } from '../../../../actions/users';
import { getAllSkills } from '../../../../actions/skills';
import { sendBulkMessageAction, getUserConversations } from '../../../../actions/conversations';
import { UIShowAlert } from '../../../../actions/ui';
import GroupMessages from './GroupMessages';

class GroupMessagesContainer extends Component {
  static propTypes = {
    skillsList: PropTypes.array.isRequired,
    workersPredictionsList: PropTypes.array.isRequired,
    searchWorkersAction: PropTypes.func.isRequired,
    clearWorkersPredictionsList: PropTypes.func.isRequired,
    getAllSkills: PropTypes.func.isRequired,
    sendBulkMessageAction: PropTypes.func.isRequired,
    getUserConversations: PropTypes.func.isRequired,
    path: PropTypes.string.isRequired
  };

  componentDidMount () {
    this.props.getAllSkills();
  }

  render () {
    return <GroupMessages {...this.props} />;
  }
}

const mapStateToProps = state => {
  return {
    workersPredictionsList: state.users.workersPredictionsList,
    skillsList: state.skillsList
  };
};

const mapDispatchToProps = {
  getAllSkills,
  searchWorkersAction,
  clearWorkersPredictionsList,
  sendBulkMessageAction,
  getUserConversations,
  UIShowAlert
};

export default connect(mapStateToProps, mapDispatchToProps)(GroupMessagesContainer);



// WEBPACK FOOTER //
// ./src/components/app/messages/groupMessages/GroupMessagesContainer.js